import { render, staticRenderFns } from "./MainBannerProduct.vue?vue&type=template&id=3f31edbb&scoped=true"
import script from "./MainBannerProduct.vue?vue&type=script&lang=js"
export * from "./MainBannerProduct.vue?vue&type=script&lang=js"
import style0 from "./MainBannerProduct.vue?vue&type=style&index=0&id=3f31edbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31edbb",
  null
  
)

export default component.exports